
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Cart"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"items_qty"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartTitleFragment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartContentFragment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartFooterFragment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CrossSellsFragment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WithCartTrackingFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minimum_order_amount"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":528}};
    doc.loc.source = {"body":"#import \"theme/modules/Cart/CartTitle/CartTitleFragment.gql\"\n#import \"theme/modules/Cart/CartContent/CartContentFragment.gql\"\n#import \"theme/modules/Cart/withCartTracking/WithCartTrackingFragment.gql\"\n#import \"theme/modules/Cart/CrossSells/CrossSellsFragment.gql\"\n#import \"theme/modules/Cart/CartFooter/CartFooterFragment.gql\"\n\nfragment CartFragment on Cart {\n  id\n  items_qty\n  ...CartTitleFragment\n  ...CartContentFragment\n  ...CartFooterFragment\n  ...CrossSellsFragment\n  ...WithCartTrackingFragment\n  minimum_order_amount\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("theme/modules/Cart/CartTitle/CartTitleFragment.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("theme/modules/Cart/CartContent/CartContentFragment.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("theme/modules/Cart/withCartTracking/WithCartTrackingFragment.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("theme/modules/Cart/CrossSells/CrossSellsFragment.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("theme/modules/Cart/CartFooter/CartFooterFragment.gql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["CartFragment"] = oneQuery(doc, "CartFragment");
        
